import { EXTERNAL_LINK_CLASS } from 'components/ExternalIntegrationLink';
import { OpenInNew } from 'components/icons';
import { downloadFile } from 'utils/downloadFile';
import { t } from 'utils/getTranslations';

export default function PdfLink({ sentInvoiceId }: { sentInvoiceId: number }) {
    return (
        <div className="self-center">
            <button
                type="button"
                className={EXTERNAL_LINK_CLASS}
                onClick={() => downloadFile(`/v1/invoices/sent-invoices/download/${sentInvoiceId}`)}
            >
                {t('invoices.pdf-link')}
                <OpenInNew fontSize="small" />
            </button>
        </div>
    );
}
